import { AfterContentInit, Component, ContentChildren, QueryList } from "@angular/core";
import { ChartTabComponent } from "./chart-tab.component";

@Component({
  selector: "app-manager-chart",
  templateUrl: "./manager-chart.component.html",
  styleUrls: ["./manager-chart.component.scss"],
})
export class ManagerChartComponent implements AfterContentInit {
  @ContentChildren(ChartTabComponent) public tabs!: QueryList<ChartTabComponent>;
  public selectedIndex = 0;

  public ngAfterContentInit(): void {
    Promise.resolve().then(() => {
      this.selectTabByIndex(0);
      this.subscribeToTabs();
    });
  }

  public selectTab(tab: ChartTabComponent): void {
    this.tabs.forEach(t => (t.active = false));
    tab.active = true;
  }

  public selectTabByIndex(index: string | number | undefined | null): void {
    if (index === undefined || index === null) {
      return;
    }
    const numericIndex = typeof index === "string" ? parseInt(index, 10) : index;
    if (isNaN(numericIndex)) {
      return;
    }
    const tab = this.tabs.get(numericIndex);
    if (tab) {
      this.selectTab(tab);
      this.selectedIndex = numericIndex;
    }
  }

  public trackByTab(index: number, tab: ChartTabComponent): string {
    return tab.title;
  }

  public subscribeToTabs(): void {
    this.tabs.changes.subscribe(() => {
      this.selectTabByIndex(0);
    });
  }
}
